import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(fetchAvailability),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(fetchMoreAvailability),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(watchFetchAvailability),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(watchFetchMoreAvailability);

import { call, put, takeLatest } from 'redux-saga/effects';
import { isEmpty } from '@sainsburys-tech/boltui-utils';
import { FETCH_AVAILABILITY, FETCH_MORE_AVAILABILITY } from '../actions/types';
import { availabilityDidYouMean, availabilityFailed, availabilityLoaded, moreAvailabilityFailed, moreAvailabilityLoaded } from '../actions/availability';
import { storeLoaded } from '../actions/storeinfo';
import getAvailability from '../helpers/getAvailability';
import getMoreAvailability from '../helpers/getMoreAvailability';
var genericServerErrorMessage = "Sorry, but the store finder isn’t working right now. We're fixing it, so please try again later.";
var responseErrorMessage = "Sorry, that didn't work! Enter your postcode or town.";
var noInputErrorMessage = 'Type in your town or postcode';
var noResultsErrorMessage = 'Sorry, there are no results for that location. Please try a different location.'; // Fetches availability and store info

function fetchAvailability(_ref) {
  var url, data, response;
  return _regeneratorRuntime.wrap(function fetchAvailability$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          url = _ref.url, data = _ref.data;
          _context.prev = 1;

          if (!(data && data.origin !== undefined && isEmpty(data.origin.trim()))) {
            _context.next = 6;
            break;
          }

          _context.next = 5;
          return put(availabilityFailed(noInputErrorMessage));

        case 5:
          return _context.abrupt("return", _context.sent);

        case 6:
          _context.next = 8;
          return call(getAvailability, url, data);

        case 8:
          response = _context.sent;

          if (!response.errorText) {
            _context.next = 13;
            break;
          }

          _context.next = 12;
          return put(availabilityFailed(responseErrorMessage));

        case 12:
          return _context.abrupt("return", _context.sent);

        case 13:
          if (!(response.suggestions && response.suggestions.length > 0)) {
            _context.next = 17;
            break;
          }

          _context.next = 16;
          return put(availabilityDidYouMean(response.suggestions));

        case 16:
          return _context.abrupt("return", _context.sent);

        case 17:
          if (!(response.stores && response.stores.length > 0 && response.stores[0].availability)) {
            _context.next = 23;
            break;
          }

          _context.next = 20;
          return put(storeLoaded(response.stores));

        case 20:
          _context.next = 22;
          return put(availabilityLoaded({
            stores: response.stores,
            orderId: data.orderId,
            safeMode: response.safeMode
          }));

        case 22:
          return _context.abrupt("return", _context.sent);

        case 23:
          _context.next = 25;
          return put(availabilityFailed(genericServerErrorMessage));

        case 25:
          return _context.abrupt("return", _context.sent);

        case 28:
          _context.prev = 28;
          _context.t0 = _context["catch"](1);

          if (!(_context.t0.message === 'Syntax Error - No results found')) {
            _context.next = 34;
            break;
          }

          _context.next = 33;
          return put(availabilityFailed(noResultsErrorMessage));

        case 33:
          return _context.abrupt("return", _context.sent);

        case 34:
          _context.next = 36;
          return put(availabilityFailed(genericServerErrorMessage));

        case 36:
          return _context.abrupt("return", _context.sent);

        case 37:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 28]]);
} // Fetches closest store with stock available to collect right now


function fetchMoreAvailability(_ref2) {
  var url, data, response;
  return _regeneratorRuntime.wrap(function fetchMoreAvailability$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          url = _ref2.url, data = _ref2.data;
          _context2.prev = 1;
          _context2.next = 4;
          return call(getMoreAvailability, url, data);

        case 4:
          response = _context2.sent;

          if (!response.stores) {
            _context2.next = 9;
            break;
          }

          _context2.next = 8;
          return put(moreAvailabilityLoaded({
            stores: response.stores,
            orderId: data.orderId
          }));

        case 8:
          return _context2.abrupt("return", _context2.sent);

        case 9:
          _context2.next = 11;
          return put(moreAvailabilityFailed(genericServerErrorMessage));

        case 11:
          return _context2.abrupt("return", _context2.sent);

        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 18;
          return put(moreAvailabilityFailed(genericServerErrorMessage));

        case 18:
          return _context2.abrupt("return", _context2.sent);

        case 19:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 14]]);
} // Watches for the 'FETCH_AVAILABILITY' action then fires the saga


export function watchFetchAvailability() {
  return _regeneratorRuntime.wrap(function watchFetchAvailability$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return takeLatest(FETCH_AVAILABILITY, fetchAvailability);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
} // Watches for the 'FETCH_MORE_AVAILABILITY' action then fires the saga

export function watchFetchMoreAvailability() {
  return _regeneratorRuntime.wrap(function watchFetchMoreAvailability$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeLatest(FETCH_MORE_AVAILABILITY, fetchMoreAvailability);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}